module.exports = __webpack_public_path__ + "img/recliner-right-tvroom-pc.fa1dcb1c.png";